module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/signature2019-934bfed9680516a213fd532e1100594e.png";